import { render, staticRenderFns } from "./order_delivery.vue?vue&type=template&id=6da7bb68&scoped=true&"
import script from "./order_delivery.vue?vue&type=script&lang=js&"
export * from "./order_delivery.vue?vue&type=script&lang=js&"
import style0 from "./order_delivery.vue?vue&type=style&index=0&id=6da7bb68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da7bb68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6da7bb68')) {
      api.createRecord('6da7bb68', component.options)
    } else {
      api.reload('6da7bb68', component.options)
    }
    module.hot.accept("./order_delivery.vue?vue&type=template&id=6da7bb68&scoped=true&", function () {
      api.rerender('6da7bb68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/orders/order/tabs/order_delivery.vue"
export default component.exports